/**
 * Scroll Reveal — observes every [data-reveal] element on the page and adds
 * .is-revealed once it scrolls into view. Reusable across any section:
 *
 *   <div data-reveal="fade-up" data-reveal-delay="150">...</div>
 *
 * Reveals once per element (doesn't re-hide on scroll-out), and does nothing
 * beyond an instant opacity flip if the visitor has reduced motion enabled —
 * the CSS handles the visual side, this only handles *when* to reveal.
 */
(function () {
  // Multiple sections (hero, product carousel, etc.) each include their own
  // <script> tag for this file, since a section's Liquid can't assume any
  // other section is present on the page. That means this same script can
  // legitimately run more than once on a page that has several of them —
  // this guard makes repeat runs a harmless no-op instead of re-observing
  // (and potentially double-triggering) the same elements.
  if (window.__scrollRevealInitialized) return;
  window.__scrollRevealInitialized = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  els.forEach(function (el) {
    var delay = el.getAttribute('data-reveal-delay');
    if (delay) el.style.setProperty('--reveal-delay', delay + 'ms');
    var distance = el.getAttribute('data-reveal-distance');
    if (distance) el.style.setProperty('--reveal-distance', distance);
  });

  if (prefersReduced || !('IntersectionObserver' in window)) {
    // Reveal everything immediately — no scroll-triggered motion to wait on.
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px 200px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
})();